/** Site-wide contact details — single source of truth. */
export const SITE_CONTACT = {
  name: "Michal Cako",
  /** Public inbox shown on the site (mailto). Not a secret. */
  email: "michal@uxmichal.com",
  location: "EU & UK · Fully remote",
  linkedIn: {
    label: "LinkedIn",
    url: "https://linkedin.com/in/lececil",
  },
} as const;
